import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import { Typeahead } from "react-bootstrap-typeahead";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";
import SibebarDescriptorsProfiles from "../../../components/descriptorsProfiles/SibebarDescriptorsProfiles";
import {
  getTitles,
  saveTitles,
  editTitles,
  deleteTitles,
} from "../../../redux/descriptorsProfiles/Titles/actions";
import { get_tasks } from "../../../redux/tasks/actions";
import { getKnowledgeAreas } from "../../../redux/descriptorsProfiles/KnowledgeAreas/actions";
import { getEducationLevel } from "../../../redux/descriptorsProfiles/EducationLevel/actions";

const Titles = (props) => {
  const filters = [
    { id: "titulo", desc: "Título" },
    { id: "nivel_academico", desc: "Nivel de educación" },
    { id: "area_conocimiento", desc: "Área de conocimiento" },
  ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [areaSelected, setAreaSelected] = useState([]);
  const [nivSelected, setNivSelected] = useState([]);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "titulo",
    desc: "Título",
  });

  const dispatch = useDispatch();

  const schema = Yup.object().shape({
    nivel_academico: Yup.string().required("**Campo requerido"),
    area_conocimiento: Yup.string().required("**Campo requerido"),
    titulo: Yup.string().required("**Campo requerido"),
  });

  const {
    loading,
    saveLoading,
    titlesLength,
    titles,
    titleError,
    formError,
    formErrorJson,
  } = useSelector((store) => store.titles);
  const pages = Math.ceil(titlesLength / limit);

  const { knowledgeAreas, knowledgeAreaError } = useSelector(
    (store) => store.knowledgeAreas
  );
  const loadingKnowledgeAreas = useSelector(
    (store) => store.knowledgeAreas.loading
  );

  const { educationLevelsLength, educationLevels, educationLevelsError } =
    useSelector((store) => store.educationLevel);

  const loadingEducationLevel = useSelector(
    (store) => store.educationLevel.loading
  );

  // const tasks = useSelector((store) => store.tasks.tasks);
  // const tasksLoader = useSelector((store) => store.tasks.loader);

  let nivelOptions = [];
  educationLevels &&
    educationLevels.map((task) => {
      nivelOptions = [
        ...nivelOptions,
        {
          id: task.id,
          label: task.nombre,
        },
      ];
    });
  let areaOptions = [];
  knowledgeAreas &&
    knowledgeAreas.map((task) => {
      areaOptions = [
        ...areaOptions,
        {
          id: task.id,
          label: task.nombre,
        },
      ];
    });

  const columns = [
    {
      Header: "Título",
      accessor: "titulo",
    },
    {
      Header: "Nivel de educación",
      accessor: "list_nivel_academico[0].nombre",
    },
    {
      Header: "Área de conocimiento",
      accessor: "list_area_conocimiento[0].nombre",
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const _getTitles = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getTitles({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter: filt,
      })
    );

  useEffect(() => {
    _getTitles();
    dispatch(get_tasks({}));
    dispatch(getKnowledgeAreas({}));
    dispatch(getEducationLevel({}));
  }, []);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setNivSelected([
      {
        id: item.nivel_academico,
        label: item.list_nivel_academico[0].nombre,
      },
    ]);
    setAreaSelected([
      {
        id: item.area_conocimiento,
        label: item.list_area_conocimiento[0].nombre,
      },
    ]);
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getTitles(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    if (!edit) {
      dispatch(saveTitles(req, setShowModal));
    } else {
      dispatch(editTitles(req, editItem.id, index, setShowModal));
    }
    setNivSelected([]);
    setAreaSelected([]);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getTitles(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteTitles(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SibebarDescriptorsProfiles show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">Títulos</h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Busqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="ml-3 mr-3">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            titlesLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={titles} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={titlesLength}
                  pages={pages}
                  pagFunc={_getTitles}
                />
              </>
            )
          )}
          {!loading && titlesLength === 0 && titleError === "" && (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience agregando algunos
            </Alert>
          )}
          {!!titleError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {titleError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setNivSelected([]);
          setAreaSelected([]);
        }}
      >
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            nivel_academico: edit
              ? editItem.nivel_academico === null
                ? ""
                : editItem.nivel_academico
              : "",
            area_conocimiento: edit
              ? editItem.area_conocimiento === null
                ? ""
                : editItem.area_conocimiento
              : "",
            titulo: edit
              ? editItem.titulo === null
                ? ""
                : editItem.titulo
              : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar título" : "Crear título"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-1">
                  <Form.Label column sm="12" md="12">
                    Nivel de educación
                  </Form.Label>
                  <Typeahead
                    id="nivel_academico"
                    name="nivel_academico"
                    isInvalid={
                      touched.nivel_academico && errors.nivel_academico
                    }
                    isValid={touched.nivel_academico && !errors.nivel_academico}
                    onBlur={handleBlur("nivel_academico")}
                    placeholder="Nivel de educación"
                    options={nivelOptions}
                    onChange={(selected) => {
                      setFieldValue(
                        "nivel_academico",
                        selected.length > 0 ? selected[0].id : ""
                      );
                      setNivSelected(selected);
                    }}
                    selected={nivSelected}
                    disabled={educationLevelsLength === 0}
                  ></Typeahead>
                  {loadingEducationLevel && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                  {touched.nivel_academico && errors.nivel_academico && (
                    <Col>
                      <small className="text-danger">
                        {errors.nivel_academico}
                      </small>
                    </Col>
                  )}
                  {!!educationLevelsError && (
                    <Col>
                      <small className="text-danger">
                        **{educationLevelsError}
                      </small>
                    </Col>
                  )}
                  {!loadingEducationLevel && educationLevelsLength === 0 && (
                    <Col>
                      <small className="text-danger">
                        **No se encontraron funciones
                      </small>
                    </Col>
                  )}
                  {formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.nivel_academico ? (
                    <Col>
                      {formErrorJson.nivel_academico.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null}
                </Form.Group>
                <Form.Group as={Col} className="mb-1">
                  <Form.Label column sm="12" md="12">
                    Área de conocimiento
                  </Form.Label>
                  <Typeahead
                    id="area_conocimiento"
                    name="area_conocimiento"
                    isInvalid={
                      touched.area_conocimiento && errors.area_conocimiento
                    }
                    isValid={
                      touched.area_conocimiento && !errors.area_conocimiento
                    }
                    onBlur={handleBlur("area_conocimiento")}
                    placeholder="Área de conocimiento"
                    options={areaOptions}
                    onChange={(selected) => {
                      setFieldValue(
                        "area_conocimiento",
                        selected.length > 0 ? selected[0].id : ""
                      );
                      setAreaSelected(selected);
                    }}
                    selected={areaSelected}
                    disabled={knowledgeAreas.length === 0}
                  ></Typeahead>
                  {loadingKnowledgeAreas && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                  {touched.area_conocimiento && errors.area_conocimiento && (
                    <Col>
                      <small className="text-danger">
                        {errors.area_conocimiento}
                      </small>
                    </Col>
                  )}
                  {!!knowledgeAreaError && (
                    <Col>
                      <small className="text-danger">
                        **{knowledgeAreaError}
                      </small>
                    </Col>
                  )}
                  {!loadingKnowledgeAreas && knowledgeAreas.length === 0 && (
                    <Col>
                      <small className="text-danger">
                        **No se encontraron funciones
                      </small>
                    </Col>
                  )}
                  {formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.area_conocimiento ? (
                    <Col>
                      {formErrorJson.area_conocimiento.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Título
                  </Form.Label>
                  <Form.Control
                    id="titulo"
                    name="titulo"
                    isInvalid={
                      (touched.titulo && errors.titulo) ||
                      (touched.titulo &&
                        formErrorJson &&
                        typeof formErrorJson === "object" &&
                        formErrorJson.archivo)
                    }
                    isValid={touched.titulo && !errors.titulo}
                    onBlur={handleBlur("titulo")}
                    onChange={handleChange}
                    value={values.titulo}
                    className="rounded-pill"
                    type="text"
                    placeholder="Título"
                  ></Form.Control>
                  {touched.titulo && errors.titulo && (
                    <Col>
                      <small className="text-danger">{errors.titulo}</small>
                    </Col>
                  )}
                  {formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.titulo ? (
                    <Col>
                      {formErrorJson.titulo.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null}
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default Titles;
